"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var core_1 = require("@angular/core");
var Observable_1 = require("rxjs/Observable");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var ReplaySubject_1 = require("rxjs/ReplaySubject");
var NavigationMessageService = /** @class */ (function () {
    function NavigationMessageService(messageService, currentLanguageProvider) {
        this.messageService = messageService;
        this.currentLanguageProvider = currentLanguageProvider;
        this.titleSubjects = new Map();
    }
    NavigationMessageService_1 = NavigationMessageService;
    NavigationMessageService.prototype.getMessage = function (messageKey) {
        if (messageKey) {
            if (messageKey.startsWith(NavigationMessageService_1.NAV_BAR_TITLE_PREFIX)) {
                return this.titleSubjects.get(messageKey).asObservable() || Observable_1.Observable.of('');
            }
            else {
                return this.messageService.getMessage(messageKey);
            }
        }
        return Observable_1.Observable.of('');
    };
    NavigationMessageService.prototype.getMessageWithPlaceholder = function (messageKey, placeholders) {
        return this.messageService.getMessageWithPlaceholder(messageKey, placeholders);
    };
    NavigationMessageService.prototype.getMessages = function (languageId, messageKeys) {
        return this.messageService.getMessages(languageId, messageKeys);
    };
    NavigationMessageService.prototype.getMessagesWithPlaceholder = function (languageId, messageKeys, placeholders) {
        return this.messageService.getMessagesWithPlaceholder(languageId, messageKeys, placeholders);
    };
    NavigationMessageService.prototype.put = function (titleKey, titles) {
        var messageSubject = new ReplaySubject_1.ReplaySubject(1);
        this.titleSubjects.set(titleKey, messageSubject);
        var s = this.currentLanguageProvider
            .getCurrentLanguage()
            .subscribe(function (language) { return messageSubject.next(titles.getValue(language.getId())); });
    };
    NavigationMessageService.prototype.getMessagesByCriteria = function (messageSearchCriteria) {
        throw new Error('Unsupported method');
    };
    NavigationMessageService.prototype.partialUpdateMessages = function (messages) {
        throw new Error('Unsupported method');
    };
    NavigationMessageService.prototype.getDetailedMessagesByCriteria = function (messageSearchCriteria) {
        throw new Error('Unsupported method');
    };
    var NavigationMessageService_1;
    NavigationMessageService.NAV_BAR_TITLE_PREFIX = 'nav.bar.custom';
    NavigationMessageService = NavigationMessageService_1 = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_message_language_service_client_js_1.MessageService, idm_session_data_provider_api_js_1.CurrentLanguageProvider])
    ], NavigationMessageService);
    return NavigationMessageService;
}());
exports.NavigationMessageService = NavigationMessageService;
//# sourceMappingURL=navigation-message-service.js.map